import type { EngineeringHealthMetric } from "@insights/contracts";

export function formatHealthValue(value: number | null, unit: EngineeringHealthMetric["unit"]) {
  if (value === null) return "—";
  if (unit === "percent") return `${Math.round(value)}%`;
  if (unit === "milliseconds") {
    const hours = value / 3_600_000;
    return hours < 1 ? `${Math.round(value / 60_000)}m` : hours < 48 ? `${hours.toFixed(1)}h` : `${(hours / 24).toFixed(1)}d`;
  }
  return Math.round(value).toLocaleString();
}
